import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

export const translations = {
  home: { en: "Home", id: "Beranda" },
  bookNow: { en: "Book Now", id: "Pesan Sekarang" },
  heroRentCollaboration: {
    en: "WhatsApp for Event / Collaboration",
    id: "WhatsApp untuk Event & Kolaborasi",
  },
  packages: { en: "Rental Packages", id: "Paket Sewa" },
  checkBooking: { en: "Check Booking", id: "Cek Pesanan" },
  faq: { en: "FAQ", id: "FAQ" },
  contact: { en: "Contact Us", id: "Hubungi Kami" },
  heroTitle: { en: "Mahjong Anywhere. Anytime.", id: "Mahjong Di Mana Saja. Kapan Saja." },
  heroSub: { en: "Portable automatic Mahjong delivered straight to your place.", id: "Meja Mahjong otomatis portabel diantar langsung ke tempat Anda." },
  bookMahjong: { en: "Book Mahjong", id: "Pesan Mahjong" },
  checkAvailability: { en: "Check Availability", id: "Cek Ketersediaan" },
  whatsappUs: { en: "WhatsApp Us", id: "WhatsApp Kami" },
  howItWorks: { en: "How It Works", id: "Cara Kerjanya" },
  steps: {
    en: ["Select your rental package", "Choose your date", "Enter your delivery location", "Confirm your booking", "Pick up your portable Mahjong at the nearest Hub", "Play & enjoy", "Return at the end of your rental"],
    id: ["Pilih paket sewa", "Pilih tanggal", "Masukkan lokasi pengiriman", "Konfirmasi pesanan", "Ambil portable Mahjong Anda di Hub terdekat", "Bermain & nikmati", "Kembalikan di akhir masa sewa"],
  },
  schedule: { en: "Schedule", id: "Jadwal" },
  package: { en: "Package", id: "Paket" },
  delivery: { en: "Delivery", id: "Pengiriman" },
  details: { en: "Details", id: "Data Diri" },
  review: { en: "Review", id: "Ringkasan" },
  whenPlay: { en: "When do you want to play?", id: "Kapan Anda ingin bermain?" },
  rentalDate: { en: "Rental Date", id: "Tanggal Sewa" },
  startTime: { en: "Start Time", id: "Waktu Mulai" },
  units: { en: "Number of Mahjong Units", id: "Jumlah Unit Mahjong" },
  continueBtn: { en: "Continue", id: "Lanjut" },
  back: { en: "Back", id: "Kembali" },
  selectPackage: { en: "Select Your Package", id: "Pilih Paket Anda" },
  select: { en: "Select", id: "Pilih" },
  selected: { en: "Selected", id: "Dipilih" },
  whereDeliver: { en: "Where Should We Deliver?", id: "Kirim Ke Mana?" },
  yourDetails: { en: "Your Details", id: "Data Anda" },
  yourBooking: { en: "YOUR BOOKING", id: "PESANAN ANDA" },
  confirmBooking: { en: "Confirm Booking", id: "Konfirmasi Pesanan" },
  promoQ: { en: "Have a Promo Code?", id: "Punya Kode Promo?" },
  apply: { en: "Apply", id: "Terapkan" },
  refundableDeposit: { en: "Refundable Deposit", id: "Deposit (Dapat Dikembalikan)" },
  totalPayment: { en: "TOTAL PAYMENT", id: "TOTAL PEMBAYARAN" },
  depositNote: { en: "Security deposit is refundable after the Mahjong unit is returned and inspected.", id: "Deposit keamanan dikembalikan setelah unit Mahjong dikembalikan dan diperiksa." },
  agreeTerms: { en: "I agree to LapakMahjong.id Rental Terms & Conditions.", id: "Saya setuju dengan Syarat & Ketentuan Sewa LapakMahjong.id." },
  viewTerms: { en: "View Rental Terms", id: "Lihat Syarat Sewa" },
  bookingReceived: { en: "Booking Received!", id: "Pesanan Diterima!" },
  loading: { en: "Loading…", id: "Memuat…" },
  bookingId: { en: "Booking ID", id: "ID Pesanan" },
  customer: { en: "Customer", id: "Pelanggan" },
  bookingStart: { en: "Start", id: "Mulai" },
  bookingQuantity: { en: "Quantity", id: "Jumlah" },
  bookingUnit: { en: "Unit", id: "Unit" },
  rentalTotal: { en: "Rental Total", id: "Total Sewa" },
  bookingStatus: { en: "Booking Status", id: "Status Pesanan" },
  bookingStatusInquiry: { en: "Inquiry", id: "Permintaan" },
  bookingStatusWaitingConfirmation: {
    en: "Waiting for Confirmation",
    id: "Menunggu Konfirmasi",
  },
  bookingStatusConfirmed: { en: "Confirmed", id: "Dikonfirmasi" },
  bookingStatusWaitingPayment: { en: "Waiting for Payment", id: "Menunggu Pembayaran" },
  bookingStatusDepositPaid: { en: "Deposit Paid", id: "DP Dibayar" },
  bookingStatusPaid: { en: "Paid", id: "Lunas" },
  bookingStatusPreparing: { en: "Preparing", id: "Sedang Disiapkan" },
  bookingStatusOutForDelivery: { en: "Out for Delivery", id: "Dalam Pengiriman" },
  bookingStatusRented: { en: "Rented / Playing", id: "Disewa / Bermain" },
  bookingStatusWaitingPickup: { en: "Waiting for Pickup", id: "Menunggu Pengambilan" },
  bookingStatusReturned: { en: "Returned", id: "Dikembalikan" },
  bookingStatusInspection: { en: "Inspection", id: "Pemeriksaan" },
  bookingStatusCompleted: { en: "Completed", id: "Selesai" },
  bookingStatusCancelled: { en: "Cancelled", id: "Dibatalkan" },
  benefit: { en: "Benefit", id: "Benefit" },
  createMemberAccount: { en: "Create Member Account", id: "Buat akun Member" },
  rentalTerms: { en: "Rental Terms", id: "Syarat & Ketentuan" },
  bookingPaymentNote: {
    en: "Transfer to the account above or scan the QRIS code, then upload your transfer receipt. "
      + "Your booking is confirmed after our team verifies the payment.",
    id: "Transfer ke rekening di atas atau scan QRIS, lalu kirim bukti transfer ke WhatsApp kami. "
      + "Booking dikonfirmasi setelah pembayaran kami terima.",
  },
  continueWA: { en: "Continue to WhatsApp", id: "Lanjut ke WhatsApp" },
  available: { en: "Available", id: "Tersedia" },
  fullyBooked: { en: "Fully Booked", id: "Penuh" },
  fullName: { en: "Full Name", id: "Nama Lengkap" },
  whatsapp: { en: "WhatsApp Number", id: "Nomor WhatsApp" },
  addons: { en: "Add-ons", id: "Tambahan" },
  welcomeBack: { en: "Welcome Back!", id: "Selamat Datang Kembali!" },
  galleryTitle: { en: "Our Customers' Moments", id: "Momen Pelanggan Kami" },
  gallerySub: {
    en: "Real photos from events we served — family gatherings, birthdays, offices and small tournaments.",
    id: "Foto asli dari acara yang kami layani — arisan, ulang tahun, kantor, sampai turnamen kecil.",
  },
  galleryAlt: { en: "Customer moment", id: "Momen pelanggan" },
  close: { en: "Close", id: "Tutup" },
  promoLastDay: { en: "Last day of the promo!", id: "Hari terakhir promo!" },
  promoTomorrow: { en: "Promo ends tomorrow", id: "Promo berakhir besok" },
  promoInDays: { en: "Promo ends in {n} days", id: "Promo berakhir dalam {n} hari" },
  readyTitle: { en: "Ready to play?", id: "Siap bermain?" },
  readySub: { en: "Book in about a minute. No account needed.", id: "Booking sekitar satu menit. Tanpa perlu akun." },
  bannerPrev: { en: "Previous banner", id: "Banner sebelumnya" },
  bannerNext: { en: "Next banner", id: "Banner berikutnya" },
  memberArea: { en: "Member", id: "Member" },
  memberDashboard: { en: "Dashboard", id: "Dasbor" },
  memberLoginTitle: { en: "Member Login", id: "Login Member" },
  memberLoginSub: {
    en: "Sign in with your website account to track bookings, tier and free-rental rewards.",
    id: "Masuk dengan akun website untuk melihat pesanan, tier, dan reward sewa gratis Anda.",
  },
  guestNote: {
    en: "Booking without an account still works — an account is optional.",
    id: "Booking tanpa akun tetap bisa — akun hanya opsional.",
  },
  perkHistory: { en: "See all your past and upcoming bookings", id: "Lihat semua pesanan lalu & mendatang" },
  perkTier: { en: "Track your member tier and discount", id: "Pantau tier member dan diskon Anda" },
  perkRewards: { en: "Collect rentals toward a free rental day", id: "Kumpulkan sewa untuk 1 hari gratis" },
  perkAddresses: { en: "Save addresses for faster booking", id: "Simpan alamat agar booking lebih cepat" },
  welcome: { en: "Welcome, {name}", id: "Selamat datang, {name}" },
  logout: { en: "Logout", id: "Keluar" },
  myBookings: { en: "My Bookings", id: "Pesanan Saya" },
  myProfile: { en: "My Profile", id: "Profil Saya" },
  savedAddresses: { en: "Saved Addresses", id: "Alamat Tersimpan" },
  currentTier: { en: "Current Tier", id: "Tier Saat Ini" },
  completedRentals: { en: "Completed Rentals", id: "Sewa Selesai" },
  totalSpend: { en: "Total Spend", id: "Total Belanja" },
  memberDiscount: { en: "member discount", id: "diskon member" },
  noDiscountYet: { en: "Rent more to unlock a discount", id: "Sewa lagi untuk membuka diskon" },
  loyaltyProgress: { en: "Loyalty Progress", id: "Progres Loyalty" },
  awayFromReward: { en: "{n} more completed rentals to unlock a Free 1 Day", id: "{n} sewa lagi untuk membuka Gratis 1 Hari" },
  rewardReady: { en: "Your Free 1 Day reward is ready!", id: "Reward Gratis 1 Hari Anda sudah siap!" },
  availableRewards: { en: "Available rewards", id: "Reward tersedia" },
  noBookings: { en: "No bookings yet.", id: "Belum ada pesanan." },
  pendingLinkTitle: { en: "Waiting for admin approval", id: "Menunggu persetujuan admin" },
  pendingLinkSub: {
    en: "We found earlier rentals on this WhatsApp number. For your safety our team verifies the number before your history appears here.",
    id: "Kami menemukan riwayat sewa pada nomor WhatsApp ini. Untuk keamanan, tim kami memverifikasi nomor dulu sebelum riwayat Anda ditampilkan.",
  },
  completeProfile: { en: "Complete Your Profile", id: "Lengkapi Profil Anda" },
  completeProfileSub: {
    en: "We only need your name and WhatsApp number so we can match your rentals and contact you about deliveries.",
    id: "Kami hanya butuh nama dan nomor WhatsApp agar bisa mencocokkan riwayat sewa dan menghubungi Anda soal pengiriman.",
  },
  profileSaved: { en: "Profile saved", id: "Profil tersimpan" },
  save: { en: "Save", id: "Simpan" },
  addAddress: { en: "Add Address", id: "Tambah Alamat" },
  addrLabel: { en: "Label (Home, Office, …)", id: "Label (Rumah, Kantor, …)" },
  addrFull: { en: "Full address", id: "Alamat lengkap" },
  addrArea: { en: "Area / District", id: "Area / Kecamatan" },
  addressSaved: { en: "Address saved", id: "Alamat tersimpan" },
  noAddresses: { en: "No saved addresses yet.", id: "Belum ada alamat tersimpan." },
  joinMemberTitle: { en: "Create Your Lapak Mahjong Member Account", id: "Buat Akun Member Lapak Mahjong" },
  joinMemberSub: {
    en: "Track bookings, see your tier, collect free-rental rewards and save addresses. Your booking stays valid either way.",
    id: "Pantau pesanan, lihat tier, kumpulkan reward sewa gratis, dan simpan alamat. Pesanan Anda tetap sah walau tidak membuat akun.",
  },
  benefitTitle: { en: "Use a member benefit?", id: "Pakai benefit member?" },
  benefitSub: {
    en: "Free rental days cover the rental fee only — delivery and deposit are still charged.",
    id: "Hari sewa gratis hanya menutup biaya sewa — pengiriman dan deposit tetap ditagih.",
  },
  useReward: { en: "Use my Free {n} Day reward", id: "Pakai reward Gratis {n} Hari" },
  useFreeDays: { en: "Use 1 of my {n} monthly free days", id: "Pakai 1 dari {n} hari gratis bulanan" },
  dontUseBenefit: { en: "Don't use a benefit this time", id: "Jangan pakai benefit kali ini" },
  payOnline: { en: "Pay Online Now", id: "Bayar Online Sekarang" },
  payOnlineSub: {
    en: "Card, GoPay, OVO, ShopeePay, QRIS or bank transfer via Midtrans.",
    id: "Kartu, GoPay, OVO, ShopeePay, QRIS, atau transfer bank lewat Midtrans.",
  },
  paidLabel: { en: "Payment received", id: "Pembayaran diterima" },
  paymentPending: { en: "Waiting for payment…", id: "Menunggu pembayaran…" },
  paymentFailed: { en: "Payment failed, please try again", id: "Pembayaran gagal, coba lagi" },
  paymentUnavailable: {
    en: "Online payment is not available yet",
    id: "Pembayaran online belum tersedia",
  },
  cityBranch: { en: "City / Branch", id: "Kota / Cabang" },
  chooseCity: { en: "Choose city", id: "Pilih kota" },

  hubLabel: { en: "Hub (table location)", id: "Hub (lokasi meja)" },
  tables: { en: "tables", id: "meja" },
  dispatchTime: { en: "Pick-up / dispatch time", id: "Jam ambil / kirim" },
  dispatchHint: {
    en: "Choose any time inside the Hub's opening hours. Return is due the same time plus {n} hour on the last day.",
    id: "Pilih jam bebas selama Hub buka. Pengembalian jatuh di jam yang sama plus {n} jam di hari terakhir.",
  },
  automaticRentalStartLabel: { en: "Automatic rental start", id: "Jam mulai sewa otomatis" },
  automaticRentalStartNote: {
    en: "Automatic rental start — follows the selected Hub’s opening time.",
    id: "Jam mulai sewa otomatis — mengikuti jam buka Hub yang dipilih.",
  },
  rentalDateHint: { en: "Choose your rental date", id: "Pilih tanggal jadwal sewa" },
  unitsAvailable: { en: "{count} units available", id: "{count} unit tersedia" },
  dateUnavailableForHub: {
    en: "This date is not available for this Hub.",
    id: "Tanggal tidak tersedia untuk Hub ini.",
  },
  useNextOpeningDate: {
    en: "Use next available date: {date}",
    id: "Gunakan tanggal buka berikutnya: {date}",
  },
  hubClosedThatDay: { en: "The Hub is closed on this date. Please pick another date.", id: "Hub tutup pada tanggal ini. Silakan pilih tanggal lain." },
  noSlotsLeft: { en: "No dispatch time left today — please pick another date.", id: "Sudah tidak ada jam kirim untuk hari ini — pilih tanggal lain." },
  returnDue: { en: "Return due", id: "Kembali paling lambat" },
  serviceQuestion: { en: "How should we serve you?", id: "Mau dilayani bagaimana?" },
  serviceByCustomer: { en: "I arrange pick-up & return myself", id: "Saya urus ambil & kembalikan sendiri" },
  serviceByLapak: { en: "Delivered by LapakMahjong.id", id: "Diantar LapakMahjong.id" },
  serviceSelfPickup: { en: "Pick Up", id: "Ambil Sendiri" },
  serviceByCustomerNote: {
    en: "No courier fee from us. You (or your own courier) collect the table at the Hub and bring it back at the end. Just continue — no address needed.",
    id: "Tanpa biaya kurir dari kami. Anda (atau kurir Anda sendiri) ambil meja di Hub dan mengembalikannya di akhir masa sewa. Lanjut saja — tidak perlu alamat.",
  },
  serviceByLapakNote: {
    en: "We deliver and collect the table. Please fill in the full address so we can calculate the courier fee.",
    id: "Kami antar dan ambil kembali mejanya. Mohon isi alamat lengkap agar biaya kurir bisa dihitung.",
  },
  pickupLocation: { en: "Pick-up location", id: "Lokasi pengambilan" },
  hubHoursNote: { en: "Hub open {open}–{close} {tz} · last pick-up {last}.", id: "Hub buka {open}–{close} {tz} · jam ambil terakhir {last}." },
  hubNotConfigured: { en: "Location details for {hub} are not configured yet ({fields}).", id: "Detail lokasi {hub} belum dilengkapi ({fields})." },
  hubNotConfiguredSub: {
    en: "We never show another Hub's address so you don't travel to the wrong place. Please choose another Hub or message us on WhatsApp.",
    id: "Kami tidak menampilkan alamat Hub lain supaya Anda tidak salah datang. Pilih Hub lain, atau chat kami di WhatsApp.",
  },
  openMaps: { en: "Google Maps", id: "Google Maps" },
  weekdayMondayOnly: { en: "Mondays only — change the date to a Monday to use this package", id: "Hanya bisa dimulai hari Senin — ganti tanggal ke Senin untuk memakai paket ini" },
  notAvailable: { en: "Not available", id: "Tidak tersedia" },
  notAvailableMonday: { en: "Not available — Mondays only", id: "Tidak tersedia — Senin saja" },
  refundAccountTitle: { en: "Deposit refund account", id: "Rekening pengembalian deposit" },
  refundAccountSub: {
    en: "We send your {amount} deposit back to this account after the table is returned and checked.",
    id: "Deposit {amount} kami kembalikan ke rekening ini setelah meja dikembalikan dan dicek. Wajib diisi dan hanya bisa dilihat Owner/Finance.",
  },
  whatsappPaymentConfirmationTitle: {
    en: "Final step — WhatsApp confirmation is required",
    id: "Langkah terakhir — wajib konfirmasi via WhatsApp",
  },
  whatsappPaymentConfirmationHelper: {
    en: "After uploading your transfer receipt, tap the button below so our team can verify your payment.",
    id: "Setelah mengunggah bukti transfer, tekan tombol di bawah agar tim kami dapat memeriksa pembayaran Anda.",
  },
  whatsappPaymentConfirmationCta: {
    en: "Confirm Payment via WhatsApp",
    id: "Konfirmasi Pembayaran via WhatsApp",
  },
  manualBankTransferTitle: {
    en: "Manual Bank Transfer (BCA)",
    id: "Transfer Bank Manual (BCA)",
  },
  manualBcaStatusNone: {
    en: "No transfer receipt uploaded",
    id: "Belum ada bukti transfer",
  },
  manualBcaStatusSubmitted: {
    en: "Receipt received — awaiting verification by our team",
    id: "Bukti diterima — menunggu verifikasi tim kami",
  },
  manualBcaStatusAccepted: {
    en: "Payment verified — booking confirmed",
    id: "Pembayaran terverifikasi — booking dikonfirmasi",
  },
  manualBcaStatusRejected: { en: "Receipt rejected", id: "Bukti ditolak" },
  manualBcaStatusReupload: {
    en: "Please upload your transfer receipt again",
    id: "Mohon unggah ulang bukti transfer",
  },
  manualBcaHoldExpired: {
    en: "The {minutes}-minute time limit has passed, so your table has been released. "
      + "Please place a new booking or contact us on WhatsApp.",
    id: "Batas waktu {minutes} menit sudah lewat, jadi meja Anda dilepas kembali. "
      + "Silakan pesan ulang atau hubungi kami lewat WhatsApp.",
  },
  manualBcaHoldPrefix: {
    en: "We are holding your table for {minutes} minutes. Time remaining",
    id: "Meja Anda kami tahan {minutes} menit. Sisa waktu",
  },
  manualBcaHoldSuffix: {
    en: "to transfer and upload your receipt.",
    id: "untuk transfer dan unggah bukti.",
  },
  manualBcaCopy: { en: "Copy", id: "Salin" },
  manualBcaCopySuccess: { en: "Account number copied", id: "Nomor rekening dikopi" },
  manualBcaAccountNumber: { en: "Account Number", id: "No. Rekening" },
  manualBcaAccountHolder: { en: "Account Holder", id: "Atas Nama" },
  manualBcaRental: { en: "Rental", id: "Sewa" },
  manualBcaRefundableDeposit: {
    en: "Refundable Deposit",
    id: "Deposit (dikembalikan)",
  },
  manualBcaTotalTransfer: { en: "Total Transfer", id: "Jumlah transfer" },
  manualBcaDepositRefundTo: { en: "Deposit Refund To", id: "Refund deposit ke" },
  manualBcaTeamNote: { en: "Our team's note:", id: "Catatan tim kami:" },
  manualBcaYourHub: { en: "YOUR HUB", id: "HUB ANDA" },
  manualBcaHubMissing: {
    en: "Location details have not been completed — our team will confirm them via WhatsApp.",
    id: "Detail lokasi belum dilengkapi — tim kami akan mengonfirmasi lewat WhatsApp.",
  },
  manualBcaVerified: {
    en: "Payment has been verified by our team. Thank you!",
    id: "Pembayaran sudah diverifikasi tim kami. Terima kasih!",
  },
  manualBcaUploadProof: { en: "Upload Transfer Receipt", id: "Unggah Bukti Transfer" },
  manualBcaReplaceProof: {
    en: "Replace Transfer Receipt",
    id: "Ganti Bukti Transfer",
  },
  manualBcaFileTypes: {
    en: "JPG, PNG, or PDF, maximum 8 MB.",
    id: "JPG, PNG, atau PDF maksimal 8 MB.",
  },
  manualBcaUploadSuccess: {
    en: "Transfer receipt uploaded. Our team will verify it manually.",
    id: "Bukti transfer terkirim. Kami verifikasi manual, ya.",
  },
  manualBcaUploadFailed: { en: "Failed to upload receipt", id: "Gagal mengunggah bukti" },
  manualBcaDashboardNote: {
    en: "The status shown in the LapakMahjong dashboard is authoritative — a WhatsApp chat is not "
      + "proof of payment. Payment is considered paid only after our team verifies the receipt.",
    id: "Status di dashboard LapakMahjong yang berlaku — chat WhatsApp bukan bukti pembayaran. "
      + "Pembayaran baru dianggap lunas setelah tim kami memverifikasi bukti.",
  },
  bankName: { en: "Bank name", id: "Nama Bank" },
  accountNumber: { en: "Account number", id: "No. Rekening" },
  accountHolder: { en: "Account holder name", id: "Nama Pemilik Rekening" },
  service: { en: "Service", id: "Layanan" },
  needMore: { en: "Need more?", id: "Butuh lebih?" },
  chatWhatsApp: { en: "Chat on WhatsApp", id: "Chat WhatsApp" },
  addonAdminConfirm: { en: "Availability confirmed by Admin after booking", id: "Ketersediaan dikonfirmasi Admin setelah booking" },
  instagramOpt: { en: "Instagram (optional)", id: "Instagram (opsional)" },
  emailOpt: { en: "Email (optional)", id: "Email (opsional)" },
  customerType: { en: "Customer type", id: "Tipe Customer" },
  howFoundUs: { en: "How did you find us? (optional)", id: "Tahu kami dari mana? (opsional)" },
  checkBookingTitle: { en: "Check My Booking", id: "Cek Pesanan Saya" },
  bookingCode: { en: "Booking Code", id: "Kode Pesanan" },
  findBooking: { en: "Find Booking", id: "Cari Pesanan" },
  bookingNotFound: { en: "Booking not found", id: "Pesanan tidak ditemukan" },
  customerName: { en: "Customer Name", id: "Nama Pelanggan" },
  bookingTotal: { en: "Booking Total", id: "Total Pesanan" },
  amountPaid: { en: "Amount Paid", id: "Jumlah Dibayar" },
  paymentStatus: { en: "Payment Status", id: "Status Pembayaran" },
  depositStatus: { en: "Deposit Status", id: "Status Deposit" },
  deliveryType: { en: "Delivery", id: "Pengiriman" },
  selfPickup: { en: "Self Pickup", id: "Ambil Sendiri" },
  vehicleBike: { en: "Bike", id: "Motor" },
  vehicleCar: { en: "Car", id: "Mobil" },
  selfPickupDiscount: { en: "Self Pickup Discount", id: "Diskon Ambil Sendiri" },
  depositRefundReceipt: { en: "Deposit Refund Receipt", id: "Bukti Pengembalian Deposit" },
  bookingDetails: { en: "Booking Details", id: "Rincian Booking" },
  rentalDateTime: { en: "Rental Date & Time", id: "Tanggal & Jam Sewa" },
  depositPaid: { en: "Deposit Paid", id: "Deposit Dibayar" },
  deduction: { en: "Deduction", id: "Potongan" },
  reason: { en: "Reason", id: "Alasan" },
  refundedToYou: { en: "Refunded To You", id: "Dikembalikan Kepada Anda" },
  method: { en: "Method", id: "Metode" },
  refundDate: { en: "Refund Date", id: "Tanggal Pengembalian" },
  allRefunds: { en: "All Refunds", id: "Semua Pengembalian" },
  totalRefunded: { en: "Total Refunded", id: "Total Dikembalikan" },
  conditionMedia: { en: "Condition Photos & Videos", id: "Foto & Video Kondisi" },
  conditionMediaSub: {
    en: "Documented by our team before and after delivery, pickup and inspection.",
    id: "Didokumentasikan oleh tim kami sebelum dan sesudah pengiriman, pengambilan, serta pemeriksaan.",
  },
  memberSignUpTitle: { en: "Create Member Account", id: "Buat akun Member" },
  memberSignUpSub: {
    en: "Use a username, email, password and WhatsApp number. No Google sign-in or OTP code.",
    id: "Gunakan username, email, password, dan nomor WhatsApp. Tanpa Google atau kode OTP.",
  },
  username: { en: "Username", id: "Username" },
  usernamePlaceholder: { en: "Example: mahjongtogether", id: "Contoh: mahjongbareng" },
  password: { en: "Password", id: "Password" },
  passwordMinPlaceholder: { en: "At least 8 characters", id: "Minimal 8 karakter" },
  confirmPassword: { en: "Confirm Password", id: "Konfirmasi password" },
  repeatPassword: { en: "Repeat password", id: "Ulangi password" },
  agreeTermsRequired: {
    en: "Please agree to the Rental Terms & Conditions first",
    id: "Centang persetujuan Syarat dan Ketentuan dulu",
  },
  memberAccountCreated: { en: "Member account created", id: "Akun Member berhasil dibuat" },
  loginSuccess: { en: "Welcome back", id: "Selamat datang kembali" },
  loginFailed: { en: "Sign-in failed. Please try again.", id: "Gagal masuk. Coba lagi." },
  enterEmailFirst: { en: "Enter your email first", id: "Isi email Anda dulu" },
  resetLinkFailed: { en: "Failed to send the link", id: "Gagal mengirim tautan" },
  signIn: { en: "Sign In", id: "Masuk" },
  signUp: { en: "Sign Up", id: "Daftar" },
  createAccount: { en: "Create Account", id: "Buat akun" },
  processing: { en: "Processing…", id: "Memproses…" },
  alreadyHaveAccount: { en: "Already have an account? Sign In", id: "Sudah punya akun? Masuk" },
  noAccount: { en: "Don't have an account? Sign Up", id: "Belum punya akun? Daftar" },
  forgotPassword: { en: "Forgot password?", id: "Lupa password?" },
  signupTermsConsent: {
    en: "I agree to the LapakMahjong.id Rental Terms & Conditions, including the Rp500.000 per-set deposit and cancellation policy.",
    id: "Saya menyetujui Syarat dan Ketentuan LapakMahjong.id, termasuk deposit Rp500.000 per set dan kebijakan pembatalan.",
  },
  signupTermsPrefix: { en: "I agree to the LapakMahjong.id", id: "Saya menyetujui" },
  signupTermsSuffix: {
    en: "including the Rp500.000 per-set deposit and cancellation policy.",
    id: "LapakMahjong.id, termasuk deposit Rp500.000 per set dan kebijakan pembatalan.",
  },
  marketingOptIn: {
    en: "Optional: send me information about promotions and new products.",
    id: "Opsional: kirimi saya info promo dan produk baru.",
  },
  resetPasswordTitle: { en: "Set a New Password", id: "Atur password baru" },
  resetNoToken: {
    en: "This link is incomplete. Request a new link from the Member sign-in page.",
    id: "Tautan tidak lengkap. Minta tautan baru dari halaman masuk Member.",
  },
  resetComplete: { en: "Password changed. Redirecting…", id: "Password sudah diganti. Mengalihkan…" },
  resetLinkLifetime: {
    en: "This link is valid for 60 minutes and can only be used once.",
    id: "Tautan berlaku 60 menit dan hanya bisa dipakai satu kali.",
  },
  passwordMinError: { en: "Password must be at least 8 characters", id: "Password minimal 8 karakter" },
  resetLinkInvalid: { en: "This link is invalid", id: "Tautan tidak valid" },
  saving: { en: "Saving…", id: "Menyimpan…" },
  saveNewPassword: { en: "Save New Password", id: "Simpan password baru" },
  memberGenericError: { en: "Something went wrong", id: "Terjadi kesalahan" },
  resetLinkSent: {
    en: "If this email is registered, we have sent a password-reset link.",
    id: "Jika email terdaftar, kami telah mengirim tautan reset password.",
  },
  paymentStatusText: {
    en: { Unpaid: "Unpaid", "DP Paid": "Deposit Paid", "Partially Paid": "Partially Paid", Paid: "Paid", Refunded: "Refunded" },
    id: { Unpaid: "Belum Dibayar", "DP Paid": "DP Dibayar", "Partially Paid": "Dibayar Sebagian", Paid: "Lunas", Refunded: "Dikembalikan" },
  },
  depositStatusText: {
    en: { "Not Paid": "Not Paid", Paid: "Paid", "Pending Return": "Pending Return", "Fully Returned": "Fully Returned", "Partially Deducted": "Partially Deducted", "Fully Deducted": "Fully Deducted" },
    id: { "Not Paid": "Belum Dibayar", Paid: "Dibayar", "Pending Return": "Menunggu Pengembalian", "Fully Returned": "Dikembalikan Penuh", "Partially Deducted": "Dipoton Sebagian", "Fully Deducted": "Dipoton Penuh" },
  },
  bookingStatusText: {
    en: {
      Inquiry: "Inquiry",
      "Waiting Confirmation": "Waiting for Confirmation",
      Confirmed: "Confirmed",
      "Waiting Payment": "Waiting for Payment",
      "DP Paid": "Deposit Paid",
      Paid: "Paid",
      Preparing: "Preparing",
      "Out for Delivery": "Out for Delivery",
      "Rented / Playing": "Rented / Playing",
      "Waiting for Pickup": "Waiting for Pickup",
      Returned: "Returned",
      Inspection: "Inspection",
      Completed: "Completed",
      Cancelled: "Cancelled",
    },
    id: {
      Inquiry: "Permintaan",
      "Waiting Confirmation": "Menunggu Konfirmasi",
      Confirmed: "Dikonfirmasi",
      "Waiting Payment": "Menunggu Pembayaran",
      "DP Paid": "DP Dibayar",
      Paid: "Lunas",
      Preparing: "Sedang Disiapkan",
      "Out for Delivery": "Dalam Pengiriman",
      "Rented / Playing": "Disewa / Bermain",
      "Waiting for Pickup": "Menunggu Pengambilan",
      Returned: "Dikembalikan",
      Inspection: "Pemeriksaan",
      Completed: "Selesai",
      Cancelled: "Dibatalkan",
    },
  },
  choose: { en: "Choose…", id: "Pilih…" },
};

export const translate = (key, lang, vars) => {
  const raw = translations[key] ? translations[key][lang] : key;
  if (!vars || typeof raw !== "string") return raw;
  return Object.entries(vars).reduce(
    (text, [name, value]) => text.replaceAll(`{${name}}`, value),
    raw,
  );
};

const Ctx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("lm_lang") || "en");
  const change = useCallback((l) => { localStorage.setItem("lm_lang", l); setLang(l); }, []);
  const t = useCallback((key, vars) => translate(key, lang, vars), [lang]);
  const value = useMemo(() => ({ lang, t, setLang: change }), [lang, t, change]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
